import { AbilityBuilder, createMongoAbility, type MongoAbility } from '@casl/ability';
import { abilitiesPlugin } from '@casl/vue';

import type { UserRole } from '@/types/auth.types';
import type { App } from 'vue';

type Action = 'manage' | 'create' | 'read' | 'update' | 'delete';
type Subject = 'Project' | 'User' | 'all';

export type AppAbility = MongoAbility<[Action, Subject]>;

export function defineAbilityFor(role: UserRole | null, userId?: string): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  switch (role) {
    case 'admin': {
      can('manage', 'all');
      break;
    }

    case 'technical_department': {
      can('manage', 'Project');
      can('read', 'User');
      break;
    }

    case 'supervisor': {
      can('read', 'Project', { supervisorId: userId } as never);
      can('read', 'User', { id: userId } as never);
      break;
    }

    default: {
      break;
    }
  }

  return build();
}

export const ability = defineAbilityFor(null);

export function installAbility(app: App): void {
  app.use(abilitiesPlugin, ability, { useGlobalProperties: true });
}
